<template>
  <div class="navbar">
    <router-link to="/" class="logo">
      <img src="@/assets/logotipo.png" />
    </router-link>

    <div class="btn-menu">
      <p style="color: white">MENU</p>
    </div>

    <div class="linksbar" style>
      <div class="bar-triang">
        <div class="bar">
          <li class="links">
            <ul>
              <router-link to="/">Home</router-link>
            </ul>
            <ul>
              <router-link to="/empresa">Empresa</router-link>
            </ul>
            <ul>
              <router-link to="/produtos">Produtos</router-link>
            </ul>
            <ul>
              <router-link to="/contato">Contato</router-link>
            </ul>
          </li>
        </div>
      </div>
    </div>

    <Menu right class="menu-toggle">
      <router-link to="/">
        <span>Home</span>
      </router-link>
      <router-link to="/empresa">
        <span>Empresa</span>
      </router-link>
      <router-link to="/produtos">
        <span>Produtos</span>
      </router-link>
      <router-link to="/contato">
        <span>Contato</span>
      </router-link>
    </Menu>
  </div>
</template>

<script>
import { Menu } from "vue-burger-menu";
export default {
  components: { Menu },
  data: () => ({
    drawer: false,
    group: null
  }),

  watch: {
    group() {
      this.drawer = false;
    }
  }
};
</script>

<style>
.navbar {
  /*         background-color: rgba(88, 88, 88, 0.532);
 */
  background-color: #313131;
  height: 130px;
  position: fixed;
  padding-left: 80px;
  padding-right: 80px;
  padding-bottom: 10px;
  padding-top: 10px;
  display: grid;
  width: 100%;
  grid-template-columns: 16% 84%;
  grid-template-areas:
    "logo links-bar";
  z-index: 999;
}


.links {
  display: flex;
  align-items: center;
  height: 100%;
  justify-content: flex-end;
}

.links ul {
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  padding-right: 28px !important;
  padding-left: 28px !important;
  cursor: pointer;
  color: #e17e4b;
  font-weight: 900;
  transition: 0.5s;
  text-transform: uppercase;
  text-align: center;
}

.links ul:hover {
  background: #e17e4b;
  color: white;
  border-top: 2px solid white;
  border-bottom: 2px solid white;
}

.links ul a {
  color: #e17e4b;
  text-decoration: none;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  font-weight: 900;
}

.links ul:hover a {
  color: white;
  text-decoration: none;
}

.bar-triang {
  width: 90%;
  border-left: 50px solid transparent;
  border-right: 0px solid transparent;
  border-bottom: 50px solid white;
}

.bar {
  position: absolute;
  height: 50px;
  right: 80px;
}

.linksbar {
  display: flex;
  align-items: center;
  justify-content: flex-end;
}

.logo {
  grid-area: logo;
  display: flex;
  align-items: center;
  justify-content: center;
  padding-top: 10px;
  padding-bottom: 10px;
}

.logo img {
  width: 200px;
}

.btn-menu {
  position: absolute;
  right: 0px;
  top: 60px;
  grid-area: btn-menu;
  padding-right: 40px;
}

.btn-menu a {
  background: rgb(34, 180, 34);
  color: white !important;
  text-transform: uppercase;
  font-size: 14px;
  font-weight: 600;
  padding: 5px 30px 5px 30px;
  text-decoration: none;
}

.linksbar {
  grid-area: links-bar;
}

.menu-toggle {
  grid-area: menu-toggle;
  display: none;
}

.btn-menu {
  display: none;
}

.bm-burger-bars {
  background-color: white !important;
}

.bm-menu {
  background: white !important;
}

.bm-item-list {
  color: #313131 !important;
  
}

.bm-item-list > * > span {
  margin-left: 10px !important;
  font-weight: 700 !important;
  color: #e17e4b !important;
}

.bm-burger-button {
  top: 70px !important;
  opacity: 0 !important;
}

/* Extra small devices (phones, 600px and down) */
@media only screen and (max-width: 600px) {
  .navbar {
    padding: 0;
    grid-template-columns: 50% 50%;
    grid-template-areas:
      "logo btn-menu"
      "logo menu-toggle";
    align-items: center;
    justify-content: center;
    height: 130px;
  }
  .linksbar {
    display: none;
  }
  .logo img {
    width: 120px;
  }

  .btn-menu,
  .menu-toggle {
    display: initial;
  }

  .btn-menu a {
    font-size: 8px;
  }
}

/* Small devices (portrait tablets and large phones, 600px and up) */
@media only screen and (max-width: 1100px) {
  .navbar {
    padding: 0;
    grid-template-columns: 50% 50%;
    grid-template-areas:
      "logo btn-menu"
      "logo menu-toggle";
    align-items: center;
    justify-content: center;
    height: 130px;
  }
  .linksbar {
    display: none;
  }
  .logo img {
    width: 120px;
  }

  .btn-menu,
  .menu-toggle {
    display: initial;
  }
}
</style>